import { AdmissionMapTranslations } from "./models/admission-map-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR";
import { enUS } from "./translactions/en-US";

export const admissionMap: Record<SupportedLanguages, AdmissionMapTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
